<template>
  <pb-dialog class="switch-dialog" :title="info.title || $t('Gattaran_mgt_Tips_NpAN' /** 提示 */)" type="warning" :visible.sync="show" width="384px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
    <span>{{ info.tipMessage }}</span>
    <span slot="footer" class="dialog-footer">
      <pb-button type="primary" secondary @click="toReturn()">{{ info.backText || $t('Gattaran_Homepage__rxJe' /*取消*/) }}</pb-button>
      <pb-button type="primary" @click="toChange()">{{ info.confirmText || $t('Gattaran_Homepage__ktsW' /*确定*/) }}</pb-button>
    </span>
  </pb-dialog>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['handleChange'],
  data() {
    return {
      show: false,
    };
  },
  methods: {
    toReturn() {
      this.show = false;
      // 控制是返回还是停留原地
      if (this.info.canBack) {
        this.$router.push(this.info.backUrl || '/home');
      }
    },
    toChange() {
      this.show = false;
      this.$emit('handleChange', this.info);
    },
  },
};
</script>

<style scoped>
.switch-dialog {
  line-height: 24px;
}
</style>
